import { httpClient } from "@coworker/http-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type UpdateUserPayload = {
  uid: string;
  countryId: string;
  storeId: string;
  teamId: string;
};

const updateUsers = async (users: UpdateUserPayload[]) =>
  await httpClient.core.patch(`/users`, {
    body: { users },
  });

const invalidateUsersQueries = (
  queryClient: ReturnType<typeof useQueryClient>
) => {
  queryClient.removeQueries({ queryKey: ["store", "users"] });
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ["storeTeams"] }),
    queryClient.invalidateQueries({
      queryKey: ["storeTeamsWithUsersCount"],
    }),
  ]);
};

export const useUpdateUsers = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateUsers,
    onSuccess: () => invalidateUsersQueries(queryClient),
  });
};
